import { useTranslation } from 'react-i18next';
import './style.scss';

export const AccessDenied = () => {
    const { t } = useTranslation();
    return (
        <>
            <h1>{t('ACCESS_DENIED')}</h1>
        </>
    );
};
